module.exports = __webpack_public_path__ + "static/media/newyear.4395d52a.png";